import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { getWeddingConfig } from '../services/wedding-config';
import DandelionBackground from './DandelionBackground';
import ScrollReveal from './animations/ScrollReveal';

const CoupleNames: React.FC = () => {
  const config = getWeddingConfig();
  const shouldReduceMotion = useReducedMotion();

  return (
    <section className="couple-names">
      {/* Subtle background texture */}
      <div className="couple-background">
        <div className="couple-background-overlay"></div>
        <DandelionBackground />
      </div>

      {/* Main Content Container */}
      <motion.div
        className="couple-content"
        initial={{ opacity: 0, scale: shouldReduceMotion ? 1 : 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: shouldReduceMotion ? 0 : 1, ease: [0.25, 0.1, 0.25, 1] as [number, number, number, number] }}
      >

        {/* "NOSOTROS" */}
        <ScrollReveal direction="up" delay={0.3}>
          <div>
            {/* <p className="nosotros-text">
              ¡Nos casamos!
            </p> */}
            <p className="venue-title-script">
              ¡Nos casamos!
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.5}>
          <div className="opening-blessing">
            <p className="blessing-text">
              <em>Un cordón de tres hilos no se rompe fácilmente</em>
            </p>
          </div>
        </ScrollReveal>

        {/* Divider */}
        <ScrollReveal direction="none" delay={0.6}>
          <div className="couple-divider"></div>
        </ScrollReveal>

        {/* Opening Blessing */}
        <ScrollReveal direction="up" delay={0.7}>
          <div className="opening-blessing">
            {/* <p className="blessing-text">
              Por la bendición de Dios y el amor de nuestros Padres, nos preparamos para unir nuestras vidas
            </p> */}

            <p className="blessing-text">
            Con Dios como el centro de nuestra unión y la bendición de nuestros padres, nos complace invitarlos a nuestra boda
            </p>
          </div>
        </ScrollReveal>

        {/* Divider */}
        <ScrollReveal direction="none" delay={0.8}>
          <div className="couple-divider"></div>
        </ScrollReveal>

        {/* Couple Names */}
        <ScrollReveal direction="up" delay={0.9}>
          <div className="names-section">
            <h1 className="couple-name">
              {config.couple.bride.toUpperCase()}
            </h1>

            {/* Elegant ampersand */}
            <div className="elegant-ampersand">
              &
            </div>

            <h1 className="couple-name">
              {config.couple.groom.toUpperCase()}
            </h1>
          </div>
        </ScrollReveal>

        {/* Divider */}
        <ScrollReveal direction="none" delay={1.0}>
          <div className="couple-divider-large"></div>
        </ScrollReveal>

        {/* Invitation Text */}
        <ScrollReveal direction="up" delay={1.1}>
          <div className="invitation-text">
            <p className="invitation-line">
            Queremos que compartan con nosotros la felicidad de este día
            </p>

          </div>
        </ScrollReveal>
      </motion.div>
    </section>
  );
};

export default CoupleNames;